import type { OrgMember } from "./admin"

// One cache entry per org for the Better Auth membership roster. Every reader
// (Members & invites, Settings overview, Vault, New DM, the New event host
// picker) MUST share the same shape under this key — `{ members, invitations }`
// exactly as listClientMembers returns it. The New event form used to cache a
// bare `members[]` array under the same key, so navigating Members → Events →
// New event handed it the object and `(data ?? []).map` crashed the app.
export const orgMembersKey = (organizationId: string | null | undefined) =>
  ["org-members", organizationId ?? null] as const

/** Members out of whatever is cached, tolerating a legacy/foreign shape
 *  (a bare array, or garbage) so a shape mismatch can never throw. */
export function memberRows(data: unknown): OrgMember[] {
  if (Array.isArray(data)) return data as OrgMember[]
  const members = (data as { members?: unknown } | null | undefined)?.members
  return Array.isArray(members) ? (members as OrgMember[]) : []
}

/** Distinct member emails, in roster order. */
export function memberEmails(data: unknown): string[] {
  const out: string[] = []
  for (const m of memberRows(data)) {
    const email = m?.user?.email
    if (typeof email === "string" && email && !out.includes(email)) out.push(email)
  }
  return out
}
